module.exports = __webpack_public_path__ + "media/wi-monitor_202103161453.e8261d71.webm";